import { cn } from "@/lib/utils";

interface MissionCardProps {
  missionId: string;
  title: string;
  description: string;
  emoji: string;
  points: number;
  isPending: boolean;
  childId: string;
  onClaim: (missionId: string) => Promise<void>;
  isClaiming: boolean;
}

export function MissionCard({
  missionId,
  title,
  description,
  emoji,
  points,
  isPending,
  onClaim,
  isClaiming,
}: MissionCardProps) {
  const isDisabled = isPending || isClaiming;

  return (
    <div
      className={cn(
        "bg-white rounded-2xl border-2 p-5 shadow-sm transition-all",
        isPending ? "border-amber-300 bg-amber-50" : "border-gray-100"
      )}
    >
      <div className="flex items-start gap-4">
        <span className="text-4xl flex-shrink-0">{emoji}</span>
        <div className="flex-1 min-w-0">
          <h3 className="font-bold text-gray-900 text-base leading-snug">{title}</h3>
          <p className="text-sm text-gray-500 mt-1 leading-relaxed">{description}</p>
          <p className="text-xs text-amber-600 font-semibold mt-2">⭐ +{points} pts</p>
        </div>
      </div>

      <div className="mt-4">
        {isPending ? (
          <div className="w-full text-center py-2.5 rounded-xl bg-amber-100 border border-amber-200 text-amber-700 text-sm font-semibold">
            ⏳ Waiting for your parent...
          </div>
        ) : (
          <button
            onClick={() => onClaim(missionId)}
            disabled={isDisabled}
            className={cn(
              "w-full py-3 rounded-xl font-bold text-base transition-all active:scale-95",
              isDisabled
                ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                : "bg-gradient-to-r from-emerald-500 to-teal-500 text-white shadow-md hover:shadow-lg"
            )}
          >
            {isClaiming ? "Sending..." : "I did it! 🎉"}
          </button>
        )}
      </div>
    </div>
  );
}
